<template>
  <b-modal
      :visible="visible"
      id="admin-edit-shipper-price-modal"
      ref="modal"
      title="Add new Shipper Price"
      hide-footer
      centered
  >
    <b-form @submit.prevent="submitForm" v-if="shipperPrice && shipperPrice.id">
      <b-form-group label="Shipper">
        <b-form-input
            :value="shipperName"
            readonly
        />
      </b-form-group>
      <b-form-group label="Destination State">
        <b-form-select
            v-model="formData.destination_state"
            :options="stateOptions"
            :state="fieldValid('destination_state')"
        />
        <b-form-invalid-feedback :state="fieldValid('destination_state')">
          {{ formValidation.destination_state }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Destination City">
        <b-form-input
            v-model.trim="formData.destination_city"
            type="text"
            name="city"
            :state="fieldValid('destination_city')"
        />
        <b-form-invalid-feedback :state="fieldValid('destination_city')">
          {{ formValidation.destination_city }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Shipping Price">
        <b-form-input
            v-model.trim="formData.price"
            type="number"
            step="any"
            min="0"
            autocomplete="off"
            :state="fieldValid('price')"
        />
        <b-form-invalid-feedback :state="fieldValid('price')">
          {{ formValidation.price }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button type="submit" variant="primary" :disabled="formState.processing">
        Update Shipper Price
        <b-spinner v-if="formState.processing" class="ml-1" small></b-spinner>
      </b-button>
      <b-btn type="button" variant="secondary" @click.prevent="close">Cancel</b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import {STATES_OPTIONS} from "../constants";
import {API_ROUTES} from "../api";

export default {
  name: "AdminShipperPriceEditModal",
  emits: ["updated"],
  props: {
    shipperPrice: {
      type: Object
    },
    visible: {
      type: Boolean,
      default: false
    },
    shippers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      formData: {
        shipper: this.shipperPrice?.shipper?.id,
        destination_state: this.shipperPrice?.destination_state,
        destination_city: this.shipperPrice?.destination_city,
        price: this.shipperPrice?.price
      },
      formValidation: {},
      formState: {
        processing: false
      },
      stateOptions: STATES_OPTIONS
    }
  },
  computed: {
    shipperOptions() {
      return this.shippers.map(shipper => ({
        value: shipper.id,
        text: `${shipper.name} - ${shipper.license_number}`
      }));
    },
    shipperName() {
      if (!this.shipperPrice.id) {
        return "";
      }

      return `${this.shipperPrice.shipper.name} - ${this.shipperPrice.shipper.license}`;
    }
  },
  methods: {
    open() {
      this.$root.$emit('bv::show::modal', 'admin-edit-shipper-price-modal');
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'admin-edit-shipper-price-modal');
    },
    fieldValid(field) {
      return typeof this.formValidation[field] !== "undefined" && this.formValidation[field].length > 0 ? false : null;
    },
    submitForm() {
      this.formState.processing = true;
      this.$api.post(`${API_ROUTES.ADMIN_SHIPPER_PRICES}/${this.shipperPrice.id}`, this.formData).then(({data}) => {
        this.$bvToast.toast('Shipper price has been successfully updated', {
          title: 'Success!',
          variant: 'success'
        });
        this.formValidation = {};
        this.$emit('updated', data.shipper_price);
      }).catch(({response: {data}}) => {
        this.$bvToast.toast(data.message ?? 'Failed to update a shipper price', {
          title: 'Error!',
          variant: 'danger'
        });
        let validationErrors = {};
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in data.errors) {
            validationErrors[fieldName] = data.errors[fieldName].join(', ');
          }
        }
        this.formValidation = validationErrors;
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  },
  watch: {
    shipperPrice(shipperPrice) {
      this.formData = {
        shipper: shipperPrice.shipper.id,
        destination_state: shipperPrice.destination_state,
        destination_city: shipperPrice.destination_city,
        price: shipperPrice.price
      };
      this.formValidation = {};
    }
  }
}
</script>